import {customElement} from "lit/decorators.js";
import {Resolution} from "../../../common/resolution";
import {resolve} from "../../../container";
import {Page} from "../../../common/page";
import {ScrollService} from "../../../common/scroll";
import {EopExecutiveBoardGallery, executiveBoardGalleryConfig} from "./executiveBoardGallery";
import StylesFour from "./executiveBoardGalleryFour.lit.scss";
import StylesCommon from "./executiveBoardGalleryCommon.lit.scss";

@customElement("eop-executive-board-gallery-4")
export class EopExecutiveBoardGalleryFour extends EopExecutiveBoardGallery {

    public static readonly styles = [StylesCommon, StylesFour];

    public constructor(resolution: Resolution = resolve(Resolution), page: Page = resolve(Page), scrollService: ScrollService = resolve(ScrollService)) {
        // has duplicate in scss
        const portraitOnStageTimeline = [0.24, 0.48, 0.72, 0.96];
        const config = executiveBoardGalleryConfig(portraitOnStageTimeline, {portraitCount: 4, hasGroupShot: true});
        super(config, resolution, page, scrollService);
    }
}
